export enum CSVElementToIncludeEnum {
    NotUsed = 0,
    Summary = 1,
    AllBalancesSingleFile = 2,
    PendingBalancesSingleFile = 3,
    BalancesSingleFile = 4,
    PerCurrencyPendingBalances = 5,
    PerCurrencyBalances = 6,
    HistoricTrades = 7,
    PerCurrencyAllBalances = 8,
    OutstandingTrades = 9
}

export const CSVElementToIncludeArray = [
    {
        id: CSVElementToIncludeEnum.Summary,
        name: 'Summary'
    },
    {
        id: CSVElementToIncludeEnum.AllBalancesSingleFile,
        name: 'All Balances Single File'
    },
    {
        id: CSVElementToIncludeEnum.PendingBalancesSingleFile,
        name: 'Pending Balances Single File'
    },
    {
        id: CSVElementToIncludeEnum.BalancesSingleFile,
        name: 'Balances Single File'
    },
    {
        id: CSVElementToIncludeEnum.PerCurrencyAllBalances,
        name: 'Per Currency All Balances'
    },
    {
        id: CSVElementToIncludeEnum.PerCurrencyPendingBalances,
        name: 'Per Currency Pending Balances'
    },
    {
        id: CSVElementToIncludeEnum.PerCurrencyBalances,
        name: 'Per Currency Balances'
    },
    {
        id: CSVElementToIncludeEnum.HistoricTrades,
        name: 'Historic Trades'
    },
    {
        id: CSVElementToIncludeEnum.OutstandingTrades,
        name: 'Outstanding Trades'
    },
];

export const CSVElementsToIncludeDefaultSelected = [
    CSVElementToIncludeEnum.Summary,
    CSVElementToIncludeEnum.AllBalancesSingleFile,
    CSVElementToIncludeEnum.HistoricTrades,
    CSVElementToIncludeEnum.OutstandingTrades,
]